import * as React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import aegean from '../media/airlines/aegean.JPG';
import aeroflot from '../media/airlines/aeroflot.JPG';
import air_arabia from '../media/airlines/air_arabia.JPG';
import wizz from '../media/airlines/wizz.JPG';
import air_france from '../media/airlines/air_france.JPG';
import austrian from '../media/airlines/austrian.JPG';
import emirates from '../media/airlines/emirates.JPG';
import fly_dubai from '../media/airlines/fly_dubai.JPG';
import lufthansa from '../media/airlines/lufthansa.JPG';
import polish_airlines from '../media/airlines/polish_airlines.JPG';
import qatar from '../media/airlines/qatar.JPG';
import Typography from "@mui/material/Typography/Typography";
const itemData = [aegean, aeroflot, air_arabia, wizz, air_france, austrian, emirates, fly_dubai, lufthansa, polish_airlines, qatar];
const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

export default function Flights() {
    return (
        <ImageList id="flights" sx={{ height: 250 }} cols={1} rowHeight={250}>
            <Typography sx={{ color: 'gold', display: 'flex', alignItems: 'center' }} variant="h5" component="h5">
                <hr className="middle-line" /> Flights
            </Typography>
            <Carousel
                swipeable={false}
                draggable={false}
                arrows={false}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={1}
                customTransition="all 3s linear"
                transitionDuration={3000}
                responsive={responsive}>
                {itemData.map((item) => (
                    <ImageListItem className={'airline-container'} key={item}>
                        <div className={'airline'} style={{
                            backgroundImage: `url(${item})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                        }}
                        ></div>
                    </ImageListItem>
                    ))}
            </Carousel>
        </ImageList>
    );
}
